export enum ANSWER_TYPE {
  MULTISELECT = 'MultiSelect',
  SINGLESELECT = 'SingleSelect',
  FREE_TEXT = 'FreeText',
  URL_SINGLE_SELECT = 'UrlSingleSelect',
}

export enum SELECTION_TYPE {
  SIMPLIFIED_ANSWERS = 'SimplifiedAnswers',
  ANSWERS = 'Answers',
}

export enum RR_QUESTION_SOURCE {
  LIBRARY = 'Library',
  CUSTOM = 'Custom',
}

export enum CONTROL_TYPE {
  DEFAULT = 'Default',
  RANGE = 'Range',
  RANGE_UP_TO = 'RangeUpTo',
  RANGE_AT_LEAST = 'RangeAtLeast',
  ADVANCED_AVAILABILITY = 'AdvancedAvailability',
}
